import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import LandingPageContainer, { LandingPageType } from "../LandingPageContainer";
import { CancelMeetingPageState } from "./CancelMeetingPageState";
import { useStore } from "../../../stores/Stores";

const RequestCancelMeeting: React.FC = observer(() => {
    const [pageState, setPageState] = useState(CancelMeetingPageState.ConfirmSendRequest);
    const { meetingStore } = useStore();

    const requestCancelMeeting = async (urlHash: string | null) => {
        if (urlHash) {
            await meetingStore.requestCancelMeeting(urlHash);
            setPageState(CancelMeetingPageState.RequestSent);
        }
    };

    return (
        <LandingPageContainer
            primaryAction={requestCancelMeeting}
            cancelMeetingPageState={pageState}
            section={LandingPageType.RequestCancel}
        />
    );
});

export default RequestCancelMeeting;
